import React from 'react'
import "./index.scss"
import qrImg from './after-service-qr.jpg'
import {NavLink} from "react-router-dom";
import intl from "react-intl-universal";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../locales/config";

export function Footer() {
    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            <div className={`mp__footer qc-footer`}>
                <div className="c-footer-website">
                    <div className="c-footer-inner">
                        <ul className="c-grid c-footer-website-columns J-qcFooterNav">

                            <li className="c-g-5 xs-24">
                                <div className="c-footer-website-group J-qcFooterNavColumn">
                                    <h3 className="c-footer-website-title J-qcFooterNavColumnTitle">
                                        <a>{intl.get('aboutUs')}</a>
                                    </h3>

                                    <ul className="c-footer-website-list J-qcFooterNavColumnList">

                                        <li>
                                            <NavLink to={'/about'}>{intl.get('company-intro')}</NavLink>
                                        </li>

                                    </ul>
                                </div>
                            </li>

                            <li className="c-g-5 xs-24">
                                <div className="c-footer-website-group J-qcFooterNavColumn">
                                    <h3 className="c-footer-website-title J-qcFooterNavColumnTitle">
                                        <a>{intl.get('productCenter')}</a>
                                    </h3>

                                    <ul className="c-footer-website-list J-qcFooterNavColumnList">
                                        <li>
                                            <NavLink to="/product/rSmartPlus">{intl.get('ggybj')}</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/product/rpex6">{intl.get('celiangyi')}</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/product/RLED6">{intl.get('guangguhua')}</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/product/R3">{intl.get('ggcz')}</NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="c-g-5 xs-24">
                                <div className="c-footer-website-group J-qcFooterNavColumn">
                                    <h3 className="c-footer-website-title J-qcFooterNavColumnTitle">
                                        <a>{intl.get('userService')}</a>
                                    </h3>

                                    <ul className="c-footer-website-list J-qcFooterNavColumnList">

                                        <li>
                                            <NavLink to="/service/qa">{intl.get('cjwt')}</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/service/after">{intl.get('shfw')}</NavLink>
                                        </li>

                                    </ul>
                                </div>
                            </li>

                            <li className="c-g-5 xs-24">
                                <div className="c-footer-website-group J-qcFooterNavColumn">
                                    <h3 className="c-footer-website-title J-qcFooterNavColumnTitle">
                                        <a>{intl.get('xwydt')}</a>
                                    </h3>

                                    <ul className="c-footer-website-list J-qcFooterNavColumnList">

                                        <li>
                                            <NavLink to="/news">{intl.get('hyxw')}</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/news">{intl.get('zhxx')}</NavLink>
                                        </li>

                                    </ul>
                                </div>
                            </li>

                            <li className="c-g-5 xs-24">
                                <div className="c-footer-website-group J-qcFooterNavColumn">
                                    <h3 className="c-footer-website-title J-qcFooterNavColumnTitle">
                                        <a>{intl.get('contactUs')}</a>
                                    </h3>

                                    <ul className="c-footer-website-list J-qcFooterNavColumnList">
                                        <li>
                                            <NavLink to="/contact/us">{intl.get('lxwm')}</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/contact/hire">{intl.get('zpxx')}</NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                        </ul>

                        <div className="c-footer-copyright">
                            <ul className="c-footer-share-links">
                                <li className="J-qcFooterWXIcon">
                                    <div className="c-footer-bubble-wrap">
                                        <div className="c-footer-share-bubble J-qcFooterWXBubble" style={{zIndex: 0}}>
                                            <div className="c-footer-share-bubble-inner">
                                                <div className="bubble-qr no-pd">
                                                    <img src={qrImg}/>
                                                </div>
                                                <p className="bubble-cnt">{intl.get('gzgzg')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                {/*<li><a href="http://weibo.com/qcloud2014" target="_blank" title="微博"><i*/}
                                {/*    className="icon weibo"></i></a></li>*/}
                                {/*<li><a href="https://www.facebook.com/TencentCloud/" target="_blank" title="facebook"*/}
                                {/*><i className="icon facebook"></i></a></li>*/}
                            </ul>

                            <div className="c-hidden c-visible-xs mobile-part">
                                <a href="tel:31062832" className="c-btn">{intl.get('gmzx')}：+ 86-020-31062832</a>
                                <NavLink className="c-footer-tel-m" to="/contact/us">联系我们</NavLink>
                                <div className="c-footer-select J-qcRegionSelector">
                                    <a className="c-footer-select-trigger J-qcRegionTrigger"><i
                                        className="icon"></i><span className="J-qcFooterRegion">中文</span></a>

                                    <div className="c-footer-dropdown J-qcFooterRegionList">
                                        <ul className="c-footer-dropdown-menu">
                                            <li className="actived"><a className="J-qcRegionOption J-qcFooterSwitcher"
                                                                       data-region="cn_zh">中文</a></li>
                                            <li><NavLink to="/"
                                                   className="J-qcRegionOption J-qcFooterSwitcher"
                                                   data-region="intl">English</NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <p className="c-footer-copyright-text">
                                <span>Copyright © 2013 - 2021</span>
                                <span>RebornEndo. All Rights Reserved.</span>
                                <span>{lang === DEFAULT_LOCALE?"瑞柏安 版权所有":""}</span>
                            </p>

                            <div className="c-hidden-xs pc-part">
                                <a href="tel:31062832" className="c-btn">{intl.get('gmzx')}：+ 86-020-31062832</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="c-footer-blogroll">
                    <div className="c-footer-inner">
                        <div className="c-footer-blogroll-main">
                            <nav className="c-footer-blogroll-links">
                                <a className="icon-tc"><span className="visually-hidden">瑞柏安</span></a>
                                <hr className="c-footer-blogroll-links-separate"/>
                                <span className="slide slide-ct">{intl.get('address')}</span>
                            </nav>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
